class Slider {
    constructor(passedElement) {
        let self = this;

        self.elem = passedElement;
        self.slideContainer = self.elem.querySelector('.slider__container');
        self.slides = self.elem.querySelectorAll('.slider__slide');
        self.slideBtns = document.querySelectorAll('.slider__nav__item');
        self.links = self.elem.querySelectorAll('.slider__link');
        self.data = {
            sliderMoving: false,
            currentSlide: 1,
            totalSlides: self.slides.length,
            slideContainerWidth: (100 * self.slides.length),
            sliderLeftPosition: 0,
            windowWidth: 0,
            panBoundary: 1,
            sliderDisabled: false,
            panPosition: 0,
            sliderAnimationClass: null,
        };
    }

    init() {
        let self = this;

        self.updateWindowWidth();
        self.slideContainer.style.width = `${self.data.slideContainerWidth}%`;

        self.setActiveSlide();
        self.slides.forEach(slide => {
            slide.style.width = `${100 / self.data.totalSlides}%`;
        });

        self.setupHammer();
        self.setupBtns();

        // Create references so we can bind 'this' and still remove the events when destroying.
        self.windowListener = self.updateWindowWidth.bind(this);
        self.keyListener = self.keydownListener.bind(this);

        window.addEventListener('resize', self.windowListener, false);
        window.addEventListener('keydown', self.keyListener, false);

        setTimeout(() => {
            self.slides.forEach(slide => {
                slide.style.transition = 'left 0.5s';
            });
        }, 500);
    }

    setupHammer() {
        let self = this;

        self.hammer = new Hammer(self.slideContainer).on('swipeleft swiperight panleft panright panend pancancel', self.handleHammer.bind(this));
    }

    handleHammer(e) {
        let self = this;

        switch (e.type) {
          case 'swipeleft':
          case 'swiperight':
            break;
          case 'panleft':
          case 'panright':
          case 'panend':
          case 'pancancel':
            self.handlePan(e);
            break;
        }
    }

    handlePan(e) {
        let self = this;

        switch (e.type) {
              case 'panleft':
              case 'panright':
                self.setContainerOffsetX(-(self.data.currentSlide - 1) * self.data.windowWidth + e.deltaX);
            break;
          case 'panend':
          case 'pancancel':
            if (Math.abs(e.deltaX) > (self.data.slideContainerWidth / self.data.totalSlides) * self.data.panBoundary) {
              if (e.deltaX > 0 && self.data.currentSlide !== 1) {
                  self.data.currentSlide = self.data.currentSlide - 1;
              } else if (e.deltaX < 0 && self.data.currentSlide !== self.data.totalSlides) {
                self.data.currentSlide = self.data.currentSlide + 1;
              }
            }

            self.setSliderPosition()

            break;
        }
    }

    setContainerOffsetX(offsetX) {
        let self = this;

        if(offsetX < 0 && offsetX > -((self.data.totalSlides - 1) * self.data.windowWidth)) {
            self.slideContainer.style.left = `${offsetX}px`;
        }
    }

    moveRight() {
        let self = this;

        if(self.data.sliderMoving) {
            return;
        }

        if(self.data.currentSlide < self.data.totalSlides) {
            this.data.currentSlide = parseInt(this.data.currentSlide) + 1;
            self.setSliderPosition()
        }
    }

    moveLeft() {
        let self = this;

        if(self.data.sliderMoving) {
            return;
        }

        if(self.data.currentSlide !== 1) {
            this.data.currentSlide = parseInt(this.data.currentSlide) - 1;

            self.setSliderPosition()
        }
    }

    updateWindowWidth() {
        let self = this;

        self.data.windowWidth = window.innerWidth;

        self.setSliderPosition();
    }

    keydownListener(evt) {
        let self = this;

        if(evt.keyCode == 39) {
            self.moveRight();
        } else if (evt.keyCode == 37) {
            self.moveLeft();
        }
    }

    setSliderPosition() {
        let self = this;

        self.data.sliderMoving = true;
        self.data.sliderLeftPosition = -((self.data.currentSlide - 1) * ((self.data.windowWidth + 0) * 1));
        self.slideContainer.style.left = `${self.data.sliderLeftPosition}px`;
        self.slideContainer.style.transition = 'all 0.8s';

        console.log(self.data.sliderMoving);
        console.log(self.data.sliderLeftPosition);

        self.setActiveSlide();

        setTimeout(() => {
            self.slideContainer.style.transition = 'all 0s';
            self.data.sliderMoving = false;
        }, 1000);
    }

    setActiveSlide(removeAll = false) {
        let self = this;
        console.log('self.data.currentSlide', self.data.currentSlide);

        self.slides.forEach(slide => {
            slide.classList.remove('active');
        });

        if(!removeAll) {
            self.slides[self.data.currentSlide - 1].classList.add('active');
        }

        self.slideBtns.forEach(btn => {
            btn.classList.remove('active');
        });

        self.slideBtns[self.data.currentSlide - 1].classList.add('active');
    }

    setupBtns() {
        let self = this;

        self.slideBtns.forEach(btn => {
            btn.addEventListener('click', (evt) => {
                if(self.data.sliderMoving) {
                    return;
                }

                this.data.currentSlide = parseInt(evt.target.getAttribute('data-slide'));

                self.setSliderPosition()
            }, false);
        })

        self.links.forEach(btn => {
            btn.addEventListener('mousedown', (evt) => {
                self.slides.forEach(slide => {
                    slide.style.transition = 'all 1.2s';
                    slide.style.left = 0;
                });
            }, false);
        });
    }

    destroy() {
        let self = this;

        window.removeEventListener('resize', self.windowListener, false);
        window.removeEventListener('keydown', self.keyListener, false);
    }
}

export default Slider;
